import { api } from '@/lib/api.js';

// TAP admin API client. Mirrors the service-layer convention (services call
// api.*, hooks call services, screens call hooks). GETs carry a cache-buster
// because the CF Pages /api/* proxy can otherwise serve a stale response
// after a mint/program/hand-off mutation (per CLAUDE.md CDN-caching note).
//
// agent scoping: pass { agent } to filter to one broker; omit for unfiltered
// (Phase 1 has one broker so unfiltered == his). The 16-char hex token id is
// format-gated server-side; callers should pass ids straight through.

function qs(params = {}) {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v != null && v !== '') u.set(k, v);
  u.set('_t', Date.now());
  return u.toString();
}

export function getBatches({ agent } = {}) {
  return api.get(`/api/tap/admin/batches?${qs({ agent })}`);
}

export function getBatchTokens(label, { agent } = {}) {
  return api.get(`/api/tap/admin/batch/${encodeURIComponent(label)}/tokens?${qs({ agent })}`);
}

export function getToken(id) {
  return api.get(`/api/tap/admin/token/${id}?${qs()}`);
}

export function mintBatch({ batch_label, count, defaults }) {
  return api.post('/api/tap/admin/batch', { batch_label, count, defaults });
}

// Set landing-page copy (badge / subhead / accent / partner logo + caption)
// for a whole batch. One server-side UPDATE WHERE batch_label → every
// already-printed tag reflects it on next tap. Empty string clears a field;
// the route validates accent is hex and the logo is a small image data URI.
export function updateBatchCopy(label, { badge_text, subhead_text, accent_color, branding_image_url, branding_caption }) {
  return api.patch(`/api/tap/admin/batch/${encodeURIComponent(label)}/copy`, {
    badge_text, subhead_text, accent_color, branding_image_url, branding_caption,
  });
}

export function setProgrammed(id, programmed) {
  return api.post(`/api/tap/${id}/programmed`, { programmed });
}

export function setHandedOut(id, { handed_out_to, undo } = {}) {
  return api.post(`/api/tap/${id}/handed-out`, { handed_out_to, undo });
}

export function revokeToken(id, reason) {
  return api.post(`/api/tap/${id}/revoke`, { reason });
}
